import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { clearHabitState, getAllMyHabits } from "../features/Habit/HabitSlice";
import "../styles/components/habit.scss";

import "react-calendar-heatmap/dist/styles.css";
import { getLastSevenDays, lsd } from "../utils/getLastSevenDays";
import WeeklyGraph from "./WeeklyGraph";
import { Backdrop, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import AddHabit from "./AddHabit";

const Habit: React.FC = () => {
  const dispatch = useDispatch();

  const { habits, isHabitFetching } = useSelector(
    (state: RootState) => state.habit
  );
  let lastSevenDays: any = [];

  useEffect(() => {
    dispatch(clearHabitState());
    dispatch(getAllMyHabits());
    lastSevenDays = getLastSevenDays();
  }, []);

  interface DateValue {
    date: string | null | undefined | Date;
    count: number;
  }

  return (
    <div className="habits-container">
      <h1>Your habit record for the week </h1>
      <AddHabit />

      <ul className="habits">
        {isHabitFetching ? (
          <div className="loading-first">
            <CircularProgress />
          </div>
        ) : habits.length > 0 ? (
          habits.map((habit) => {
            let datesArray: DateValue[] = [];

            if (habit.dates_worked) {
              habit.dates_worked.map((d, index) => {
                datesArray.push({ date: d, count: index });
              });
            }

            return (
              <li key={habit.habit_id} className="habit">
                <Link to={`/graph/${habit.habit_id}`} className="habit-link">
                  {habit.habit_name}
                  {habit.habit_description ? (
                    <b className="habit-description">
                      - {habit.habit_description}
                    </b>
                  ) : (
                    <></>
                  )}
                </Link>
                <WeeklyGraph
                  datesWorked={[false, true, false]}
                  habitId={habit.habit_id}
                />
              </li>
            );
          })
        ) : (
          <p className="no-habits-message" style={{ textAlign: "center" }}>
            No habits found! Please add some habits to track them.
          </p>
        )}
      </ul>
    </div>
  );
};
export default Habit;
